<template xmlns="http://www.w3.org/1999/html">
  <div class="page-scan-in">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">珠海倉庫</div>
      <div class="breadcrumb-item">多件掃描入庫</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="11">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>重量</span>
                </div>
                <Input v-model="form.weight" placeholder="KG" clearable></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快遞單號</span>
                </div>
                <Input
                  v-model="form.odd_numbers"
                  @on-blur="getOdd"
                  @keyup.enter.native="getOdd"
                  clearable
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>澳門手機號/會員號</span>
                </div>
                <Input
                  v-model="form.recipient_phone"
                  @on-blur="getPickAddressByPhone"
                  clearable
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>尺寸</span>
                </div>
                <Select
                  placeholder="請選擇"
                  v-model="form.size"
                  @on-change="
                    form.long = '';
                    form.height = '';
                    form.wide = '';
                  "
                >
                  <Option :value="0">默認</Option>
                  <Option :value="1">厚度小於5cm</Option>
                  <Option :value="2">厚度大於5cm</Option>
                </Select>
              </FormItem>

              <div>
                <FormItem v-if="form.size != 0">
                  <div slot="label" class="form-label">
                    <em class="red">* </em>
                    <span>最長邊</span>
                  </div>
                  <Input
                    v-model="form.long"
                    @on-blur="getPickByLong"
                    clearable
                  ></Input>
                </FormItem>

                <FormItem v-else>
                  <div slot="label" class="form-label">
                    <em class="red">* </em>
                    <span>長X寬X高</span>
                  </div>
                  <div style="overflow: hidden">
                    <Row :gutter="16">
                      <Col span="8">
                        <Input
                          placeholder="長(CM)"
                          v-model="form.long"
                          ref="long_id"
                          @on-blur="getPickByLong"
                          @keyup.enter.native="onTab1"
                          clearable
                        ></Input>
                      </Col>
                      <Col span="8">
                        <Input
                          placeholder="寬(CM)"
                          v-model="form.wide"
                          ref="wide_id"
                          @on-blur="getPickByWide"
                          @keyup.enter.native="onTab2"
                          clearable
                        ></Input>
                      </Col>
                      <Col span="8">
                        <Input
                          placeholder="高(CM)"
                          v-model="form.height"
                          ref="height_id"
                          @on-blur="getPickByHeight"
                          @keyup.enter.native="onTab3"
                          clearable
                        ></Input>
                      </Col>
                    </Row>
                  </div>
                </FormItem>
              </div>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快件明細</span>
                </div>
                <Input
                  v-model="form.detailed_name"
                  ref="detailed_name"
                  placeholder="请输入快件明细"
                  clearable
                ></Input>
              </FormItem>

              <!--<FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快件明細</span>
                </div>
                <Select
                  ref="select"
                  placeholder="請選擇"
                  loading-text="加載中"
                  not-found-text="無匹配數據"
                  filterable
                  :loading="isLoadingDeliver"
                  :remote-method="handleSearchDeliverLocalSession"
                  @on-query-change="handleQueryChange"
                  v-model="form.detailed"
                  clearable
                >
                  <Option
                    :value="item.id"
                    :label="item.name"
                    v-for="(item, index) in deliverList"
                    :key="item.id"
                  >
                    {{ item.number }} {{ item.name }} {{ item.pinyin }}
                  </Option>
                </Select>
              </FormItem>-->

              <FormItem>
                <div slot="label" class="form-label">
                  <span>指令錄入</span>
                </div>
                <Input
                  ref="command_id"
                  @keyup.enter.native="onSubmit"
                  clearable
                ></Input>
              </FormItem>

              <FormItem>
                <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handlePrintCode">
                    打印條碼
                  </div>
                  <div class="pg-btn style2" @click="handleCheckForm">入庫</div>
                </div>
              </FormItem>

              <FormItem>
                <div class="form-tip-text">
                  <p style="color: black">
                    指令說明：<br />
                    客戶ID：4-5位<br />
                    手機號查找：以 + 開頭<br />
                    面單代碼：7位到30位<br />
                    重量：以 . 開頭（.1；.2；.0.1；.0.2）<br />
                    尺寸：- 開頭，（-1；-2；-3）<br />
                    長寬高：以 * 開始<br />
                    快件明细：以 / 開頭（/手機）<br />
                  </p>
                  <p style="color: red">打印條碼：Ctrl + s</p>
                </div>
              </FormItem>
            </Form>
          </Col>

          <Col span="11" offset="2">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>客戶名稱</span>
                </div>
                <Input v-model="form.recipient_contacts" clearable></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>提貨櫃點</span>
                </div>

                <Select
                  placeholder="請選擇門店"
                  not-found-text="無匹配數據"
                  clearable
                  filterable
                  v-model="form.arrive"
                  @on-change="handleArriveSelect"
                  style="width: 49%"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>

                <Select
                  placeholder="請選擇智能櫃"
                  not-found-text="無匹配數據"
                  clearable
                  filterable
                  v-model="form.arrive_cabinet"
                  @on-change="handleArriveSelectCabinet"
                  style="width: 49%; margin-left: 5px"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress_cabinet"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>收件方式</span>
                </div>
                <Select placeholder="- - -" v-model="form.arrive_type" disabled>
                  <Option :value="1">門店</Option>
                  <Option :value="2">智能櫃</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>異常件</span>
                </div>
                <Select placeholder="請選擇" v-model="form.abnormal_id">
                  <Option :value="0">無</Option>
                  <Option
                    :value="item.id"
                    v-for="(item, index) in deliverExc"
                    :key="item.id"
                    :disabled="item.id == 2 || item.title == '食品附加費'"
                  >
                    {{ item.title }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>珠海到付運費 X 1.3</span>
                </div>
                <Input v-model="form.freight_collect" clearable></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>數量</span>
                </div>
                <InputNumber
                  :min="1"
                  v-model="form.count"
                  clearable
                ></InputNumber>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>违禁品</span>
                </div>
                <Input v-model="form.contraband" clearable></Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>违禁品百分比%</span>
                </div>
                <Input v-model="form.contraband_percentage" clearable></Input>
              </FormItem>
            </Form>
            <div style="color: #4cc93e; font-size: 32px; margin-bottom: 22px">
              <span style="margin-right: 20px">是否大件出库</span>
              <Switchs true-color="#51f4a9" v-model="checkedOut" />
            </div>
            <div style="color: #4cc93e; font-size: 32px; margin-bottom: 22px">
              <span style="margin-right: 20px">自动重量</span>
              <Switchs
                true-color="#51f4a9"
                v-model="isopenSerial"
                @on-change="changeSerial"
              />
            </div>
            <div
              style="
                font-size: 120px;
                color: #ff9a65;
                font-family: Arial;
                text-align: left;
              "
            >
              <div>${{ counterSum2 }}</div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <!--    <PrintInCode ref="print_box"/>-->
    <!-- <PrintInCode4 ref="print_box" /> -->
    <!-- 新纸张缩小 新面单3 -->
    <PrintInCode5 ref="print_box" />
  </div>
</template>

<script>
import utils from "../../../assets/js/utils";
import { LineBreakTransformer } from "../../../assets/js/LineBreakTransformer";
import PrintInCode from "../../../components/PrintInCode";
import PrintInCode4 from "../../../components/PrintInCode4";
import PrintInCode5 from "../../../components/PrintInCode5";

var port, reader, readableStreamClosed;
export default {
  name: "scanInMore",
  components: {
    PrintInCode,
    PrintInCode4,
    PrintInCode5,
  },
  data() {
    return {
      localdetailList: [],
      deliverListAll: [], //所有快件明細
      deliverList: [], //快件明細，截取
      pickAddress: [], //門店
      pickAddress_cabinet: [], //智能櫃
      packageType: [], //包裹類型
      deliverExc: [], //異常件
      err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
      suc_audio:
        "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
      isLoadingDeliver: false,
      // arrive_type_status: false,
      form: {
        weight: "", //重量單位g
        odd_numbers: "", //單號
        recipient_phone: "", //澳門手機號
        long: "", //長
        wide: "", //寬
        height: "", //高
        size: 0, //尺寸，1: 最長邊大於50cm; 2: 小於5cm
        detailed: "", //快件明細id
        detailed_name: "", //快件明細id
        instructions: "", //指令
        recipient_contacts: "", //澳門客戶名稱
        arrive: "", //門店
        arrive_cabinet: "", //智能櫃
        // goods_type: '',  //包裹類型id
        arrive_type: "", //收件方式: 1門店，2:智能櫃
        abnormal_id: "", //異常id
        freight_collect: "", //珠海到付運費
        count: 1, //數量
        contraband: "", // 违禁品
        contraband_percentage: "", // 违禁品百分比
      },
      isSubmiting: false,
      pdfUrl: "",
      counterSum: 0,
      counterSum2: 0,
      checkedOut: false, // 是否同时出库
      keepReading: true,
      isopenSerial: false,
      print_box: null,
    };
  },
  mounted() {
    this.getDeliverList();
    this.getPackageType();
    this.getPickAddress();
    this.getPickAddress_cabinet();
    this.getDeliverExc();
    document.onkeydown = (event) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.handlePrintCode();
      }
    };
  },
  watch: {
    "form.long": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.wide": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.height": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.weight": utils.throttle(function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    }),
    "form.size": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.abnormal_id": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.freight_collect": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.contraband_percentage": function (val, oldVal) {
      if (!val) val = 0;
      this.counterSum2 =
        parseFloat(this.counterSum) +
        parseFloat(this.form.contraband) * (parseFloat(val) / 100);
    },
    /* "form.detailed": function (val, oldVal) {
      if (
        val === 6066 ||
        val === 7241 ||
        val === 7441 ||
        val === 7243 ||
        val === 9856
      )
        this.form.abnormal_id = 2;
      else this.form.abnormal_id = 0;
    }, */
  },
  async beforeDestroy() {
    /*if (port) {
       await this.closeSerial();
       port = null,reader = null, readableStreamClosed = null
    }*/
  },

  methods: {
    async serial() {
      // 浏览器支持serial
      if ("serial" in navigator) {
        try {
          // 提示用户选择一个串口
          port = await navigator.serial.requestPort();
          this.open();
        } catch (e) {
          this.$message.warning("用户取消选择串口");
          this.isopenSerial = false;
          console.log(e);
        }
      } else {
        alert("你的浏览器不支持串口连接");
      }
    },
    // 打开串口
    async open() {
      // 等待串口打开
      try {
        await port.open({ baudRate: 9600 });
        console.log("串口打开成功", port);

        if (port.readable) {
          this.$message.success("串口打开成功");
          this.isopenSerial = true;
          this.keepReading = true;
          await this.getWeight();
        } else {
          this.isopenSerial = false;
          this.$message.success("串口打开失败");
        }
      } catch (e) {
        this.isopenSerial = false;
        await this.closeSerial();
        (port = null), (reader = null), (readableStreamClosed = null);
        this.$message.warning("串口关闭");
      }
    },
    // 获取重量
    async getWeight() {
      if (!port.readable.locked) {
        const textDecoder = new TextDecoderStream();
        readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
        reader = textDecoder.readable
          .pipeThrough(new TransformStream(new LineBreakTransformer()))
          .getReader();
      }

      while (port.readable && this.keepReading) {
        try {
          while (true) {
            const { value, done } = await reader.read();
            if (done) {
              // reader.releaseLock()
              break;
            }
            // console.log(value)
            const pattern = /[0-9.]*kg/gi;
            const match = value.match(pattern);
            const weightString = match?.[0] || "0.000kg";
            const weight = parseFloat(weightString.replace("kg", ""));
            this.seWeight(weight);
          }
        } catch (e) {
          console.log(e);
        } finally {
          await reader.releaseLock();
        }
      }
      await port.close();
    },

    seWeight: utils.throttle(function (weight) {
      // console.log(weight)
      this.form.weight = weight;
    }, 100),

    // 关闭串口
    async closeSerial() {
      try {
        this.keepReading = false;
        await port.forget();
        await reader.cancel();
        this.form.weight = 0;
        this.$message.warning("串口关闭");
      } catch (e) {
        console.log(e);
      } finally {
        window.location.reload();
      }
    },

    changeSerial(e) {
      console.log(e);
      if (e) {
        this.serial();
      } else {
        this.closeSerial();
      }
    },

    conunterPrice() {
      let { form } = this.$data;
      let data = {
        long: form.long,
        wide: form.wide,
        height: form.height,
        weight: form.weight,
        size: form.size,
        abnormal_id: form.abnormal_id,
        freight_collect: form.freight_collect,
      };
      if (data.size == 0) {
        this.counterSum = 0;
        this.counterSum2 = 0;
        if (data.long && data.wide && data.height && data.weight) {
          this.setCounter(data);
        }
      } else if (data.size == 1 || data.size == 2) {
        if (data.long && data.weight) {
          this.setCounter(data);
        }
      }
    },
    setCounter(data) {
      if (data.abnormal_id == 0) {
        data.abnormal_id = "";
      }
      this.$Rq
        .requestAuth({
          method: "post",
          url: this.$Api.counterSums,
          data,
        })
        .then((res) => {
          this.counterSum = res.data.amount || 0;
          this.counterSum2 = res.data.amount || 0;
        })
        .catch((err) => {
          this.counterSum = 0;
          this.counterSum2 = 0;
        });
    },
    onTab1() {
      this.$refs.wide_id.focus();
    },
    onTab2() {
      this.$refs.height_id.focus();
    },
    onTab3() {
      this.$refs.select.isFocused = true;
    },
    async getOdd() {
      if (this.odd_numbers == "") {
        return false;
      }
      await this.getItem();
    },
    async getItem() {
      this.interception = false;
      await this.$Rq
        .requestAuth({
          url: this.$Api.isorder,
          method: "get",
          data: {
            order: this.form.odd_numbers,
          },
        })
        .then(async (res) => {
          if (res.code == 0) {
            this.$Utils.showTipInfo("該單號已存在");
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
          } else if (res.code == 3) {
            this.interception = true;
            this.$Utils.showTipInfo(
              `該單號已被拦截，请联系客服处理，拦截原因：${res.msg}`
            );
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
          } else if (res.code === 1 && res.data.goods_name) {
            /*
            {
                "stationcode": "AYD082",
                "name": "澳门地址",
                "mobile": "13100000000",
                "goods_name": "集运测试商品003",
                "user_id": 104069,
                "is_del": 0
            }
           recipient_phone
            detailed_name
            */
            this.form.detailed_name = res.data.goods_name;
            this.form.recipient_phone = res.data.mobile;
            this.is_pdd = true;
            // this.$refs.wide_ref?.focus();
            await this.getPickAddressByPhone();
          }
        })
        .catch((err) => {
          this.$Utils.showTipInfo("网络异常");
          let audio = new Audio();
          audio.src = this.err_audio;
          audio.play();
        });
    },
    async onSubmit(event) {
      this.form.instructions = event.target.value; // 获取输入框的值
      // +手机号
      if (this.form.instructions.charAt(0) == "+") {
        this.form.recipient_phone = this.form.instructions.substr(1);
        this.form.instructions = "";
        event.target.value = "";
        event.target.value = "";
        this.getPickAddressByPhone();
        return false;
      }

      // .重量
      if (this.form.instructions.indexOf(".") != -1) {
        if (this.form.instructions.charAt(0) == ".") {
          this.form.weight = this.form.instructions.substr(1);
        } else {
          this.form.weight = this.form.instructions;
        }
        this.form.instructions = "";
        event.target.value = "";
        return false;
      }
      // t长宽高
      if (this.form.instructions.charAt(0) == "*") {
        if (!this.form.long) {
          this.form.long = this.form.instructions.substr(1);
          this.form.instructions = "";
          event.target.value = "";
          return false;
        } else {
          if (this.form.size == 0) {
            if (!this.form.wide) {
              this.form.wide = this.form.instructions.substr(1);
              this.form.instructions = "";
              event.target.value = "";
              return false;
            } else {
              if (!this.form.height) {
                this.form.height = this.form.instructions.substr(1);
                this.form.instructions = "";
                event.target.value = "";
                return false;
              }
            }
          } else {
            this.form.long = this.form.instructions.substr(1);
            this.form.instructions = "";
            event.target.value = "";
            return false;
          }
        }
      }
      // 客户代码 4-5
      if (
        this.form.instructions.length <= 6 &&
        this.form.instructions.length >= 4 &&
        this.form.instructions.charAt(0) != "/" &&
        this.form.instructions.charAt(0) != "-" &&
        this.form.instructions.charAt(0) != "." &&
        this.form.instructions.charAt(0) != "*"
      ) {
        this.form.recipient_phone = this.form.instructions.substr(0);
        this.form.instructions = "";
        event.target.value = "";
        this.getPickAddressByPhone();
        return false;
      }
      // /xx搜索商品详情
      if (this.form.instructions.charAt(0) == "/") {
        let value = this.form.instructions.substr(1);
        // this.handleSearchDeliverLocalSession(value);
        // setTimeout(() => {
        //   this.$refs.select.visible = true;
        //   this.$refs.select.isFocused = true;
        // }, 500);
        this.form.detailed_name = value;
        this.form.instructions = "";
        event.target.value = "";
        return false;
      }
      // 快递单号
      if (
        this.form.instructions.length > 6 &&
        this.form.instructions.length < 31
      ) {
        this.form.odd_numbers = this.form.instructions;
        await this.getItem();
        this.handlePrintCode();
        this.form.instructions = "";
        event.target.value = "";
        return false;
      }
      // 快件类型 -1 默认 -2厚度小于5 -3厚度大于5
      if (this.form.instructions.charAt(0) == "-") {
        if (this.form.instructions == "-1") {
          this.form.size = 0;
          this.form.long = "";
          this.form.wide = "";
          this.form.height = "";
        } else if (this.form.instructions == "-2") {
          this.form.size = 1;
          this.form.wide = "";
          this.form.height = "";
        } else if (this.form.instructions == "-3") {
          this.form.size = 2;
          this.form.wide = "";
          this.form.height = "";
        }
        this.form.instructions = "";
        event.target.value = "";
      }
    },
    //快件明細
    getDeliverList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverList,
          method: "get",
          data: {
            /* offset: 0,
           limit: 200,
           keywords: ''*/
          },
        })
        .then((res) => {
          if (res.code == 0) {
            let resData = res.data.data;
            this.deliverListAll = resData;
            // this.deliverList = resData.slice(0, 100);
            this.deliverList = resData;
            this.localdetailList = resData;
            sessionStorage.setItem(
              "jyb_detailed",
              JSON.stringify(this.localdetailList)
            );
          }
        });
    },
    //包裹類型
    getPackageType() {
      this.$Rq
        .requestAuth({
          url: this.$Api.packageType,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.packageType = res.data.data;
          }
        });
    },
    //門店
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 1,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data;
          }
        });
    },

    //智能櫃
    getPickAddress_cabinet() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 2,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress_cabinet = res.data.data;
          }
        });
    },
    //異常件
    getDeliverExc() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverExc,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.deliverExc = res.data.data;
          }
        });
    },
    //根據手機號獲取提貨櫃點,以及客戶名稱
    getPickAddressByPhone() {
      let form = this.form;
      if (form.recipient_phone !== "") {
        this.$Rq
          .requestAuth({
            url: this.$Api.getInfoByPhone + "/" + form.recipient_phone,
            method: "get",
          })
          .then((res) => {
            let store_type =
              res.data.receiving == null ? "" : res.data.receiving.Type;
            if (res.code == 0) {
              if (res.data.length == 0) {
                this.$Utils.showTipInfo("用戶不存在");
                // return false;
              }

              if (store_type == 1) {
                let resData = res.data || {};
                this.form.recipient_contacts = resData.user_id
                  ? resData.user_name
                  : "";
                this.form.recipient_phone = resData.user_id
                  ? resData.phone
                  : ""; // 會員號碼 match 電話號碼
                this.form.arrive = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_cabinet = "";
                this.form.arrive_type = resData.receiving
                  ? resData.receiving.Type
                  : "";
                // this.arrive_type_status = true;
              } else if (store_type == 2) {
                let resData = res.data || {};
                this.form.recipient_contacts = resData.user_id
                  ? resData.user_name
                  : "";
                this.form.recipient_phone = resData.user_id
                  ? resData.phone
                  : ""; // 會員號碼 match 電話號碼
                this.form.arrive = "";
                this.form.arrive_cabinet = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_type = resData.receiving
                  ? resData.receiving.Type
                  : "";
                // this.arrive_type_status = true;
              } else if (store_type == undefined) {
                let resData = res.data || {};
                this.form.recipient_contacts = resData.user_id
                  ? resData.user_name
                  : "";
                this.form.recipient_phone = resData.user_id
                  ? resData.phone
                  : ""; // 會員號碼 match 電話號碼
                this.form.arrive = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_cabinet = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_type = resData.receiving
                  ? resData.receiving.Type
                  : "";
                // this.arrive_type_status = false;
              } else {
                this.form.recipient_contacts = "";
                this.form.recipient_phone = "";
                this.form.arrive = "";
                this.form.arrive_cabinet = "";
                this.form.arrive_type = "";
                // this.arrive_type_status = false;
              }
            }
          });
      } else {
        this.form.recipient_contacts = "";
        this.form.arrive = "";
        this.form.arrive_cabinet = "";
      }
    },
    //根據长度识别异常件
    getPickByLong() {
      let long = this.form.long;
      if (this.form.size != 0) {
        if (long > 50) {
          this.$Utils.showTipInfo("最長邊輸入不合法");
        }
      }
      if (long > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
    },
    getPickByWide() {
      let wide = this.form.wide;
      if (this.form.size != 0) {
        if (wide > 50) {
          this.$Utils.showTipInfo("最長邊輸入不合法");
        }
      }
      if (wide > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
    },
    getPickByHeight() {
      let height = this.form.height;
      if (this.form.size != 0) {
        if (height > 50) {
          this.$Utils.showTipInfo("最長邊輸入不合法");
        }
      }
      if (height > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
    },

    handleQueryChange(value) {
      if (value === "") {
        // this.deliverList = this.deliverListAll.slice(0, 100);
        this.deliverList = this.deliverListAll;
      }
    },
    handleSearchDeliver(value) {
      this.isLoadingDeliver = true;
      this.deliverList = [];
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverList,
          method: "get",
          data: {
            /* offset: 0,
           limit: 200,*/
            keywords: value,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.isLoadingDeliver = false;
            this.$nextTick(() => {});
            this.deliverList = res.data.data;
          }
        })
        .catch((err) => {
          this.isLoadingDeliver = false;
        });
    },

    //快件下拉搜索LocalSession
    handleSearchDeliverLocalSession(value) {
      let deliverListAll = JSON.parse(sessionStorage.getItem("jyb_detailed"));
      this.isLoadingDeliver = true;
      let queryData = deliverListAll.filter((item) => {
        return (
          item.name.indexOf(value) > -1 ||
          (item.number && item.number.toString().indexOf(value) > -1) ||
          item.pinyin.toLowerCase().indexOf(value.toLowerCase()) > -1
        );
      });
      this.$nextTick(() => {
        this.deliverList = queryData;
      });
      this.isLoadingDeliver = false;
    },

    //門店選擇
    handleArriveSelect(value) {
      if (
        value == undefined &&
        this.form.arrive == undefined &&
        (this.form.arrive_cabinet != undefined ||
          this.form.arrive_cabinet != "" ||
          this.form.arrive_cabinet != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.form.arrive == undefined &&
        this.form.arrive_cabinet == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      // this.arrive_type_status = true;
      this.form.arrive = value;
      this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃
      this.form.arrive_cabinet = "";
    },

    //智能櫃選擇
    handleArriveSelectCabinet(value) {
      if (
        value == undefined &&
        this.form.arrive_cabinet == undefined &&
        (this.form.arrive != undefined ||
          this.form.arrive != "" ||
          this.form.arrive != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.form.arrive_cabinet == undefined &&
        this.form.arrive == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress_cabinet;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      // this.arrive_type_status = true;
      this.form.arrive_cabinet = value;
      this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃
      this.form.arrive = "";
    },

    //提交
    async handleCheckForm() {
      let form = this.form;
      if (this.interception) {
        return this.$Utils.showTipInfo(
          "入库失败，包裹被拦截，请联系仓管或客服处理"
        );
      }
      if (form.weight == "" || form.weight == 0) {
        this.$Utils.showTipInfo("請輸入重量");
        return;
      }
      if (form.odd_numbers == "") {
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }
      if (form.odd_numbers.length < 6) {
        return this.$Utils.showTipInfo("快遞單號不能小於6位數");
      }
      if (form.recipient_phone == "") {
        this.$Utils.showTipInfo("請輸入澳門手機號或會員號碼");
        return;
      }

      // if (form.size > 0)
      // {
      //     this.$Utils.showTipInfo('請選擇尺寸');
      //     return;
      // }

      /*else if (form.arrive_type === '')
      {
          this.$Utils.showTipInfo('請選擇收件方式');
          return;
      }*/

      //校验长宽高
      if (!this.handleCheckLength()) {
        return;
      }

      // if (!(form.detailed > 0)) {
      //   this.$Utils.showTipInfo("請選擇快件明細");
      //   return;
      // }
      if (!form.detailed_name) {
        this.$Utils.showTipInfo("請選擇快件明細");
        return;
      }
      if (form.recipient_contacts == "") {
        this.$Utils.showTipInfo("請輸入客戶名稱");
        return;
      }
      if (form.arrive == "" && form.arrive_cabinet == "") {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == null && form.arrive_cabinet == null) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == undefined && form.arrive_cabinet == undefined) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }

      await this.handleSubmit();
      this.$refs.command_id.focus();
    },

    handleCheckLength() {
      let form = this.form;
      let long = Number(form.long);
      let wide = Number(form.wide);
      let height = Number(form.height);
      let arr = [long, wide, height];
      let max = Math.max(...arr);
      let min = Math.min(...arr);

      if (form.size == 1) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入最長邊");
          return false;
        }

        if (!(form.long > 1 && form.long <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      }
      if (form.size == 0) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入長");
          return false;
        }
        if (form.wide === "") {
          this.$Utils.showTipInfo("請輸入寬");
          return false;
        }
        if (form.height === "") {
          this.$Utils.showTipInfo("請輸入高");
          return false;
        }

        if (max <= 50) {
          this.$Utils.showTipInfo("最長邊應大於50cm");
          return false;
        }
      }
      if (form.size == 2) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入最長邊");
          return false;
        }

        if (!(form.long >= 1 && form.long <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      }
      if (form.size == 4) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入長");
          return false;
        }
        if (form.wide === "") {
          this.$Utils.showTipInfo("請輸入寬");
          return false;
        }
        if (form.height === "") {
          this.$Utils.showTipInfo("請輸入高");
          return false;
        }

        if (min <= 5) {
          this.$Utils.showTipInfo("厚度應大於5cm");
          return false;
        }
        if (!(max >= 1 && max <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      }

      return true;
    },

    async handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;
      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }
      const arr1 = [...this.pickAddress, ...this.pickAddress_cabinet];
      const flag = arr1.find((item) => item.ReceivingID == shop_arrive);
      this.$Rq
        .requestAuth({
          url: this.$Api.scanIn,
          method: "post",
          data: {
            weight: Number(form.weight),
            odd_numbers: form.odd_numbers,
            recipient_phone: form.recipient_phone,
            long: Number(form.long),
            wide: Number(form.wide),
            height: Number(form.height),
            size: Number(form.size),
            detailed: Number(form.detailed),
            detailed_name: form.detailed_name,
            instructions: form.instructions,
            recipient_contacts: form.recipient_contacts,
            arrive: shop_arrive,
            // goods_type: Number(form.goods_type),
            arrive_type: Number(form.arrive_type)
              ? Number(form.arrive_type)
              : 1, // 取货方式 1:门店取货; 2:智能柜取货
            abnormal_id: form.abnormal_id ? Number(form.abnormal_id) : 0,
            freight_collect: Math.round(Number(form.freight_collect) * 1.3),
            count: Number(form.count),
            contraband: Number(form.contraband),
            contraband_percentage: Number(form.contraband_percentage),
          },
        })
        .then((res) => {
          this.isSubmiting = false;

          if (res.code == 0) {
            if (res.msg == "入庫成功!") {
              if (this.checkedOut) {
                // 同时出库
                this.$Rq
                  .requestAuth({
                    url: this.$Api.scanOut,
                    method: "post",
                    data: {
                      sack_number: form.odd_numbers,
                      odd_numbers: form.odd_numbers,
                      // arrive_type: form.arrive_type, //1是門店，2是智能櫃,
                      arrive: shop_arrive, //門店或智能櫃id
                      type: 1,
                    },
                  })
                  .then((re) => {
                    this.$Utils.showSuccess(
                      `大件----${res.msg}--大件--${re.msg}`
                    );
                    let audio = new Audio();
                    audio.src = this.suc_audio;
                    audio.play();
                  })
                  .catch((er) => this.$Utils.showTipInfo(er.msg));
              } else {
                if (flag.north_pick_up == 1) {
                  // 同时出库
                  this.$Rq
                    .requestAuth({
                      url: this.$Api.scanOut,
                      method: "post",
                      data: {
                        sack_number: form.odd_numbers,
                        odd_numbers: form.odd_numbers,
                        // arrive_type: form.arrive_type, //1是門店，2是智能櫃,
                        arrive: shop_arrive, //門店或智能櫃id
                        type: 1,
                      },
                    })
                    .then((re) => {
                      this.$Utils.showSuccess(`----${res.msg}----${re.msg}`);
                      let audio = new Audio();
                      audio.src = this.suc_audio;
                      audio.play();
                    })
                    .catch((er) => this.$Utils.showTipInfo(er.msg));
                } else {
                  this.$Utils.showSuccess(res.msg);
                  let audio = new Audio();
                  audio.src = this.suc_audio;
                  audio.play();
                }
              }
            } else {
              this.$Utils.showSuccess(res.msg);
              let audio = new Audio();
              audio.src = this.err_audio;
              audio.play();
            }
            this.deliverList = this.deliverListAll;
            (form.odd_numbers = ""), //單號
              (this.form = form);
          } else {
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          let audio = new Audio();
          audio.src = this.err_audio;
          audio.play();
          this.isSubmiting = false;
        });
    },

    async print_war() {
      if (this.interception) {
        return this.$Utils.showTipInfo(
          "入库失败，包裹被拦截，请联系仓管或客服处理"
        );
      }
      const form = this.form;
      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }
      this.$refs.print_box.printCode(
        {
          order: form.odd_numbers,
          user_phone: form.recipient_phone,
          store_id: shop_arrive,
        },
        (res) => {
          res == "yes"
            ? this.$Message.success("打印成功")
            : this.$Message.error("打印失败");
        }
      );
    },
    //打印條碼
    async handlePrintCode() {
      let form = this.form;
      if (form.weight === "") {
        this.$Utils.showTipInfo("請輸入重量");
        return;
      }
      if (form.odd_numbers === "") {
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }
      if (form.odd_numbers.length < 6) {
        return this.$Utils.showTipInfo("快遞單號不能小於6位數");
      }
      if (form.size === "") {
        this.$Utils.showTipInfo("請選擇尺寸");
        return;
      }
      //校验长宽高
      if (!this.handleCheckLength()) {
        return;
      }
      if (form.arrive == "" && form.arrive_cabinet == "") {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == null && form.arrive_cabinet == null) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == undefined && form.arrive_cabinet == undefined) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.count === "") {
        this.$Utils.showTipInfo("請選擇數量");
        return;
      }
      if (form.detailed_name === "") {
        this.$Utils.showTipInfo("請選擇快件明細");
        return;
      }

      // 入库
      await this.handleCheckForm();
      this.print_war();
      return;

      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }

      let token = localStorage.getItem("jyb_token");
      let params = {
        //Authorization: token,
        odd_numbers: form.odd_numbers,
        arrive: shop_arrive,
        amount: form.count,
        weight: form.weight,
        size: form.size,
        long: Number(form.long),
        wide: Number(form.wide),
        height: Number(form.height),
        tel: form.recipient_phone,
        arrive_type: form.arrive_type,
        abnormal_id: form.abnormal_id ? Number(form.abnormal_id) : 0,
        freight_collect: Number(form.freight_collect) * 1.3,
        contraband: Number(form.contraband),
        contraband_percentage: Number(form.contraband_percentage),
        //time: new Date().getTime()
      };

      // this.pdfUrl = this.$Api.deliverCode + '?' + this.$Utils.formateObjToParamStr(params);
      // window.open(this.pdfUrl);

      this.$Rq
        .requestAuth({
          url: this.$Api.deliverCode2,
          method: "get",
          data: params,
          headers: {
            responseType: "blob",
          },
        })
        .then((res) => {
          let blob = new Blob([res], { type: "text/html;charset=utf-8" });
          let urlPdf = window.URL.createObjectURL(blob);
          let newWindow = window.open(urlPdf, false);
          if (window.print) {
            newWindow.print();
          }
          newWindow.addEventListener("afterprint", function () {
            newWindow.document.close();
            window.URL.revokeObjectURL(urlPdf);
            newWindow.close();
          });
        });
      // 入库
      this.handleCheckForm();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "ScanInMore.scss";
</style>
